export default __webpack_public_path__ + "static/img-app-explain-7b73be5ea4ead59a8405ce490eb8c422.jpg";